import moment from 'moment';

export const getQueryEnd = billingEnd => {
  const monthEnd = moment().endOf('month').valueOf();
  return billingEnd > monthEnd ? billingEnd : monthEnd;
};
